import { BiUserVoice } from 'react-icons/bi'
import { Link } from 'react-router-dom'
import { Box, Button, Card, Image, Text } from 'theme-ui'

export default function LandingPage() {
  return (
    <Card>
      <Box mb={4}>
        <Image
          src="https://png.pngtree.com/png-vector/20191122/ourmid/pngtree-megaphone-vector-illustration-isolated-on-white-background-megaphone-clip-art-png-image_2016772.jpg"
          width="200px"
          sx={{ float: 'left' }}
        />
        <Text>
          Assalamu'alaikum #HajiMuda,

          Badan Pengelola Keuangan Haji berkomitmen menerapkan prinsip Good Corporate Governance secara konsisten dan berkesinambungan, dengan aplikasi Whistle Blowing System yang memberikan kesempatan bagi kamu yang memiliki informasi dan ingin melaporkan adanya tindakan korupsi, pencurian, kekerasan, pelanggaran kode etik atau tindakan melanggar hukum, yang dilakukan oleh pegawai/pimpinan BPKH. 

          Kamu dapat melaporkan melalui wbs.bpkh.go.id atau hubungi WA contact center WBS di 0853-1900-0140/0853-1900-0150

          #BPKHRI #HajiIndonesia #JemaahIndonesia #AyoNabungHaji #HajiMuda #InfoHaji #DanaHajiAman #DanaHajiUntukUmat #MudaNaikHaji
        </Text>
      </Box>

      <Box
        sx={{
          p: 3,
        }}
      >
        <YoutubeEmbed embedId={'wAeGnDx5Ex8'}/>
      </Box>

      <Box sx={{ textAlign: 'center' }}>
        <Button
          as={Link}
          //@ts-ignore
          to="/laporan-pengaduan/create"
        >
          Buat Laporan
          <Box as={BiUserVoice} ml={2} mb={-1} />
        </Button>
      </Box>
    </Card>
  )
}

const YoutubeEmbed = ({ embedId }) => (
  <div style={{
    overflow: 'hidden',
    paddingBottom: '56.25%',
    position: 'relative',
    height: 0,
  }}>
    <iframe
      style={{
        left: 0,
        top: 0,
        height: '100%',
        width: '100%',
        position: 'absolute',
      }}
      width="853"
      height="480"
      src={`https://www.youtube.com/embed/${embedId}`}
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      title="Embedded youtube"
    />
  </div>
);